export const PLUMBING_PIPES = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加水暖管爆裂保险条款',
    register_number: '（注册号：C00001032122018073010762）',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，因高压、碰撞、严寒、高温造成主险保险单载明地址的房屋（以下简称“被保险房屋”）内或邻居家或公共区域的自来水管道、暖气管道（含暖气片）、下水管道以及太阳能热水器室内外管道爆裂，由此造成主险保险标的的损失，保险人按照本附加险合同的约定负责赔偿。'
                },
                {
                    order: '第二条',
                    context: '上述原因造成被保险房屋内的自来水管道、暖气管道（含暖气片）、下水管道以及太阳能热水器室内外管道爆裂，由此产生的修复费用，保险人按照本附加险合同的约定也负责赔偿。'
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第三条',
                    context: '下列任何原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人私自改动原管道设计；' },
                        { text: '（二）施工不慎导致管道爆裂；' },
                        { text: '（三）管道安装、检修、试水、试压。' }
                    ]
                },
                {
                    order: '第四条',
                    context: '下列损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）管道破裂致使供水中断造成的损失；' },
                        { text: '（二）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（三）其他不属于本保险责任范围内的损失、费用。' }
                    ]
                }
            ]
        },
        {
            intro: '其他事项',
            list: [ { order: '第五条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' } ]
        }
    ]
}